import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../ui/custom-table";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import {
  deleteEventData,
  deleteRoomData,
  EventApi,
  getRoomDettails,
} from "../../api/api";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Rooms() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [room, setRoom] = useState([]);
  //console.log("room", room);
  const [loading, setLoading] = useState(false);
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );

  const fecthRooms = async () => {
    setLoading(true);
    try {
      const data = await getRoomDettails();
      if (data?.data?.status === true) {
        setRoom(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fecthRooms();
  }, []);

  useEffect(() => {
    if (showModal === false) {
      fecthRooms();
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      { accessorKey: "room_no", header: "Room  No" },
      { accessorKey: "room_name", header: "Room Name" },
      { accessorKey: "room_description", header: "Room Description" },

      {
        header: "Subject Name",
        accessorKey: "subject_info.subject_name",
        Cell: ({ row }) => row.original?.subject_info?.subject_name || "-",
      },

      {
        accessorKey: "created_at",
        header: "Created At",
        Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
      },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDROOM",
        showModal: true,
      })
    );
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDROOM",
        showModal: true,
        data: row._id,
      })
    );
  };

  const handleDelete = async (row) => {
    try {
      const deleteData = await deleteRoomData(row._id);
      if (deleteData) {
        toast("deleted Successfully");
        fecthRooms();
      }
    } catch (error) {
      //console.log("error", error);
    }
  };
  return (
    <>
      <aside className="mainSection">
        <CustomTable
          columns={columns}
          data={room}
          loading={loading}
          showActions={true}
          onAddClick={handleAddClick}
          addButtonLabel="Add Room"
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </aside>
    </>
  );
}

export default Rooms;
